import React, { PureComponent } from 'react';
import strings from 'helper/localization/localization';

export default class SignupResearch extends PureComponent {
  constructor(props) {
    super(props);
    this.state = {
      researchAccepted: false
    };

    this.updateDetails = this.props.updateDetails;
    this.signUp = this.props.signUp;

    this.toNextStep = this.toNextStep.bind(this);
    this.researchChanged = this.researchChanged.bind(this);
  }

  toNextStep(e) {
    e.preventDefault();
    this.updateDetails('acceptedContactUsage', this.state.researchAccepted);
    this.signUp();
  }

  researchChanged(e) {
    this.setState({ researchAccepted: e.target.checked });
  }

  render() {
    return (
      <form>
        <div className="row">
          <div className="col">
            <div className="form-check">
              <input
                className="form-check-input"
                type="checkbox"
                id="researchCheck"
                onChange={this.researchChanged}
                checked={this.state.researchAccepted}
              />
              <label className="form-check-label" htmlFor="researchCheck">
                {strings.contactMeForStudies}
              </label>
            </div>
          </div>
        </div>
        <button
          type="submit"
          className="btn btn-outline-primary btn-lg btn-block"
          onClick={this.toNextStep}
          id="signup-research--save"
        >
          {strings.finishSignup}
        </button>
      </form>
    );
  }
}



// WEBPACK FOOTER //
// ./src/modules/signup/components/SignupResearch.jsx